import { MapType, MapViewport } from 'components/map/factory/utils/mapClasses.js';
import { StaticMap } from 'components/map/map-view/static/map-factory-view-static.js';
import { DisplayLoading } from 'layout/module-load/module-load-state.js';
import { ColumnLayoutContext } from 'page-context/column-layout/column-layout-context.js';
import * as React from 'react';
import { IMapV2 } from 'types/location.js';
interface IMapToRender {
  map: IMapV2 | undefined;
}

const _MapToRender = ({ map }: IMapToRender) => {
  const isLaptop = React.useContext(ColumnLayoutContext) !== '1-column';
  const isStatic = Boolean(map?.config.isStatic);

  if (map) {
    if (isLaptop && isStatic) {
      return (
        <div className={`${MapType.STATIC} ${MapViewport.PrimarySection}`}>
          <StaticMap {...map} />
        </div>
      );
    }
    /** MapDynamic is map that can be zoomed on mobile or desktop */
    const MapMain = React.lazy(() => import(`lazy/components.lazy/map-main.js`));

    return (
      <React.Suspense fallback={<DisplayLoading moduleName={'mapMainComponent '} isMobile={!isLaptop} />}>
        <MapMain {...map} mapTopoLayer={map.config.mapLayer} showTilePreview={true} />
      </React.Suspense>
    );
  }

  // no map e.g. mobile with no map view
  return null;
};

/**
 * Returns map type to render: mobile dynamic, desktop dynamic, desktop static
 * Wrapped in memo as offset constantly updates parent component so we need to use memo to prevent refresh on scrolling
 * */
export const MapToRender = React.memo(_MapToRender);
